import React from 'react';

import type { Props as AlumniDiscountProps } from './subcomponents/InformationBlocks/AlumniDiscount';
import type { Props as CampusProps } from './subcomponents/InformationBlocks/Campus';

import Grid, { Col } from 'Components/Grid';

import UCASCode from './subcomponents/InformationBlocks/UCASCode';
import UCASPoints from './subcomponents/InformationBlocks/UCASPoints';
import AlumniDiscount from './subcomponents/InformationBlocks/AlumniDiscount';
import EntryRequirement from './subcomponents/InformationBlocks/EntryRequirement';
import Campus from './subcomponents/InformationBlocks/Campus';
import ProfessionalCDP from './subcomponents/InformationBlocks/ProfessionalCDP';

import { Wrapper, InformationBlocks, Spacer } from './CourseInformation.styled';

interface ProfessionalCDPProps {
    label: string;
    text: string;
}
export interface Props {
    ucasCode?: string;
    ucasPoints?: string;
    entryRequirement?: string;
    alumniDiscount?: AlumniDiscountProps;
    duration?: ProfessionalCDPProps;
    delivery?: ProfessionalCDPProps;
    institutionCode: string;
    campus?: CampusProps;
    backgroundColor?: React.CSSProperties['color'];
}

const CourseInformation: React.FC<Props> = props => {
    const {
        ucasCode,
        ucasPoints,
        institutionCode,
        entryRequirement,
        alumniDiscount,
        campus,
        duration,
        delivery,
        backgroundColor
    } = props;

    return ucasCode || ucasPoints || alumniDiscount || duration || campus ? (
        <Wrapper
            style={
                {
                    '--bg-color': backgroundColor
                } as React.CSSProperties
            }
        >
            <Grid>
                <Col>
                    <InformationBlocks>
                        {ucasCode && (
                            <UCASCode ucasCode={ucasCode} institutionCode={institutionCode} />
                        )}
                        {ucasPoints && <UCASPoints points={ucasPoints} />}
                        {alumniDiscount && entryRequirement && (
                            <>
                                <EntryRequirement entryRequirement={entryRequirement} />
                                <AlumniDiscount {...alumniDiscount} />
                            </>
                        )}
                        {duration && delivery && (
                            <>
                                <ProfessionalCDP {...duration} />
                                <ProfessionalCDP {...delivery} />
                                <Spacer />
                            </>
                        )}
                        {campus && <Campus {...campus} />}
                    </InformationBlocks>
                </Col>
            </Grid>
        </Wrapper>
    ) : null;
};

export default CourseInformation;
